import React from 'react';

interface BrandMarkProps {
  label: string;
}

const BrandMark: React.FC<BrandMarkProps> = ({ label }) => {
  return (
    <div className="brand-mark" aria-label="Snake Game brand">
      <span className="brand-mark__icon" aria-hidden="true">
        <span />
        <span />
        <span />
        <span />
      </span>
      <span className="brand-mark__copy">
        <strong>Snake Game</strong>
        <small>{label}</small>
      </span>
    </div>
  );
};

export default BrandMark;
